<template>
  <div class="sk-fading-circle">
    <div class="sk-circle1 sk-circle"></div>
    <div class="sk-circle2 sk-circle"></div>
    <div class="sk-circle3 sk-circle"></div>
    <div class="sk-circle4 sk-circle"></div>
    <div class="sk-circle5 sk-circle"></div>
    <div class="sk-circle6 sk-circle"></div>
    <div class="sk-circle7 sk-circle"></div>
    <div class="sk-circle8 sk-circle"></div>
    <div class="sk-circle9 sk-circle"></div>
    <div class="sk-circle10 sk-circle"></div>
    <div class="sk-circle11 sk-circle"></div>
    <div class="sk-circle12 sk-circle"></div>
  </div>
</template>

<script>
export default {
  name: "BaseSpinner"
};
</script>

<style lang="scss" scoped>
.sk-fading-circle {
  @include sizing(80px);

  margin: 100px auto;
  position: relative;

  .sk-circle {
    @include sizing(100%);
    @include absolute(left 0 top 0);

    &::before {
      @include circle(15%);

      content: "";
      display: block;
      margin: 0 auto;
      background-color: $color-blue-300;
      -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
      animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
    }
  }

  @for $i from 2 through 12 {
    .sk-circle#{$i} {
      -webkit-transform: rotate(30deg * ($i - 1));
      -ms-transform: rotate(30deg * ($i - 1));
      transform: rotate(30deg * ($i - 1));

      &::before {
        -webkit-animation-delay: -1.3s + ($i * .1s);
        animation-delay: -1.3s + ($i * .1s);
      }
    }
  }
}

@-webkit-keyframes sk-circleFadeDelay {
  0%,
  39%,
  100% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }
}

@keyframes sk-circleFadeDelay {
  0%,
  39%,
  100% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .sk-fading-circle {
    margin: 0;
  }
}
</style>
